export enum FormFieldType {
  TEXT = "TEXT",
  EMAIL = "EMAIL",
  PASSWORD = "PASSWORD",
  TEXTAREA = "TEXTAREA",
  TOGGLE = "TOGGLE",
  CHECKBOX = "CHECKBOX",
  DATE = "DATE",
  DATERANGE = "DATERANGE",
  TIME = "TIME",
  CURRENCY = "CURRENCY",
  NUMBER = "NUMBER",
  SUGGESTIONS = "SUGGESTIONS",
  CUSTOM = "CUSTOM",
  AUTOCOMPLETE = "AUTOCOMPLETE",
  MONTHRANGE = "MONTHRANGE",
  MONTH = "MONTH",
  SELECTION = "SELECTION",
  BOOLEANSELECTION = "BOOLEANSELECTION",
  FILEUPLOADER = "FILEUPLOADER",
  HORIONTALFIELDGROUP = "HORIONTALFIELDGROUP",
  SELECTIONTILE = "SELECTIONTILE",
  SEARCHRESULTS = "SEARCHRESULTS",
  CHOICE = "CHOICE",
  TABLELIST = "TABLELIST",
  TABLELISTSELECTION = "TABLELISTSELECTION",
  EDITABLETABLE = "EDITABLETABLE",
  EDITABLETABLETAB = "EDITABLETABLETAB",
  FORMFIELDSELECTOR = "FORMFIELDSELECTOR",
  DIMENSIONSELECTOR = "DIMENSIONSELECTOR",
  SELECTIONREADONLYFIELD = "SELECTIONREADONLYFIELD",
  DIMENSIONINPUTSELECTOR = "DIMENSIONINPUTSELECTOR",
  MULTIPLEINPUT = "MULTIPLEINPUT",
  RADIOSELECTIONGROUP = "RADIOSELECTIONGROUP",
  CHECKBOXSELECTIONGROUP = "CHECKBOXSELECTIONGROUP",
  MULTIPLESELECTION = "MULTIPLESELECTION",
  NUMBERRANGE = "NUMBERRANGE",
  CURRENCYRANGE = "CURRENCYRANGE",
  DEFAULTTAG = "DEFAULTTAG",
  MULTIPLEAUTOCOMPLETE = "MULTIPLEAUTOCOMPLETE",
  COMPACTEDITABLETABLE = "COMPACTEDITABLETABLE",
  SUBFORM = "SUBFORM",
  DIMENSIONMULTIPLEINPUTSELECTOR = "DIMENSIONMULTIPLEINPUTSELECTOR",
}

export enum FormSectionType {
  FIELDGROUPSECTION = "FIELDGROUPSECTION",
  EXPANDABLESECTION = "EXPANDABLESECTION",
  WIZARDTAB = "WIZARDTAB",
  SIMPLETAB = "SIMPLETAB",
  DIALOGWIZARD = "DIALOGWIZARD",
}

export enum Toggle {
  NO = 0,
  YES = 1,
}

export enum ExpandableFormSummaryType {
  SELECTEDCOUNT = "SELECTEDCOUNT",
  VALIDATION = "VALIDATION",
}
